/* eslint-disable consistent-this */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-invalid-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiIfExistUsername, validStudentInfo } from '@/service/common';
import { cloneDeep } from 'lodash';
import {useUserInfo} from '@hooks/hooks';

// 手机号码正则
export const usernameReg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;

// 数字和字母的组合正则 （密码）
export const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/;

export const numberReg = /^[0-9]*$/;

export const numberOrLetterReg = /^[A-Za-z0-9]+$/;

/**
 * 验证手机号码是不是被注册了
 * @params userId
 * @params username
 */

export const checkUsernameExist = async (username: string, userId?: number) => {
  const { data, msg } = await apiIfExistUsername(username, userId);
  // if (data === true) {
  //   return Promise.resolve();
  // } else {
  //   return Promise.reject(msg);
  // }
  return data ? Promise.resolve() : Promise.reject(msg);
};

export const checkStudentInfo = async (params: ValidStudentInfo) => {
  const { data, msg } = await validStudentInfo(params);
  return data ? Promise.resolve() : Promise.reject(msg);
};


// 判断字符串是不是指定的长度或者长度范围 (form校验)
export const ifLengthValid = (v: string, range: number[], required = false) => {
  if (!required && !v) {
    return Promise.resolve();
  }
  if (!range) {
    return Promise.reject('输入有误');
  } else if (range.length === 1) {
    // 确定长度
    if (v.length === range[0]) {
      return Promise.resolve();
    } else {
      return Promise.reject(`输入长度必须为${range[0]}个字符！`);
    }
  } else if (range.length === 2) {
    // 指定范围
    if (v.length >= range[0] && v.length <= range[1]) {
      return Promise.resolve();
    } else {
      return Promise.reject(`输入长度必须为${range[0]}~${range[1]}个字符！`);
    }
  } else {
    return Promise.reject('输入有误');
  }
};

// 判断是否有特殊字符串或空格
export const isCharValid = (name: string, spe?: boolean) => {
  const specialRegular = new RegExp(
    spe ?
      '[`~!@#$^&*=|{}\':;\',\\[\\].<>/?~！@#￥……&*——|{}【】‘；：”“\'。，、？]':
      '[`~!@#$^&*()=|{}\':;\',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“\'。，、？]'
  );
  const spaceRegular = new RegExp(/\s/);
  if (specialRegular.test(name) || spaceRegular.test(name)) {
    return Promise.reject('不能含有特殊字符和空格');
  } else {
    return Promise.resolve();
  }
};
// logout的时候 清除

export const clearLocalStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('state');
  localStorage.removeItem('schoolId');
  localStorage.removeItem('userInfo');
};

export const filterNull: <T>(props: T) => T = props => {
  if (!props) return props;
  if (props instanceof Array) {
    const list = cloneDeep(props);
    list.forEach(i => {
      if (typeof i === 'object') {
        for (const key in i) {
          if (i[key] === '' || i[key] === null || i[key] === undefined) {
            i[key] = '-';
          }
        }
      }
    });
    return list;
  }
  return props;
};

export const formatSearchParams = (queryParams: Record<string, unknown> = {}) => {
  return Object.entries(queryParams).reduce((a, [key, value]) => {
    return a + key + '=' + value + '&';
  }, '?');
};

/**
 * @param needRole string | string[]
 * @returns Boolean
 * @description 页面上判断是否有权限
 */
export const hasPermission = (needRole?: string[] | string) => {
  // 用户已经有的权限
  const state = JSON.parse(localStorage.getItem('userInfo') || '{}');
  if (state.userType === 'EDU') {
    const userRole = state.permissionCodes;
    if (!userRole || userRole.length === 0) return false;
    else if (typeof needRole === 'string') return userRole.includes(needRole);
    // 看数据是否存在交集 (存在则有权限， 反之则无)
    else if (needRole instanceof Array) return needRole.length + userRole.length !== Array.from(new Set([...needRole, ...userRole])).length;
    else return true;
  }
  else return true;
};
